/** @jsx jsx */
import {
  Box,
  Modal,
  ModalActionButton,
  ModalContainer,
  ModalFooter,
  ModalHeader,
  ModalHeading,
  ModalProps,
} from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { IConsultantProfile } from "@/data/consultant-profiles";
import { ConsultantProfileCard } from "@/views/consultant-profiles/ConsultantProfileCard";

interface BlockedProfileModalProps extends ModalProps {
  profile: IConsultantProfile;
}

export const BlockedProfileModal: FC<BlockedProfileModalProps> = ({ profile, ...modalProps }) => {
  const { t } = useTranslation("session");

  return (
    <Modal aria-label={t("COMPONENTS.TOPBAR.CONTEXT_DROPDOWN.BLOCKED_PROFILE")} {...modalProps}>
      <ModalContainer>
        <ModalHeader
          onCloseClick={modalProps.dialogState.hide}
          closeButtonAriaLabel={t("COMPONENTS.MODAL.CLOSE")}
          headerPlaceholder={<ModalHeading>{t("COMPONENTS.TOPBAR.CONTEXT_DROPDOWN.BLOCKED_PROFILE")}</ModalHeading>}
        />

        <Box sx={{ px: ["0", null, "sm"] }}>
          <ConsultantProfileCard profile={profile} />
        </Box>

        <ModalFooter>
          <ModalActionButton type="button" variant="primary" onClick={modalProps.dialogState.hide}>
            {t("COMPONENTS.TOPBAR.CONTEXT_DROPDOWN.I_UNDERSTAND")}
          </ModalActionButton>
        </ModalFooter>
      </ModalContainer>
    </Modal>
  );
};
